import React, { useEffect } from 'react'
import { NavLink, Outlet } from 'react-router-dom';
import { CgProfile } from "react-icons/cg";
import { useState } from 'react';
import axios from 'axios';
import { MdModeEditOutline } from "react-icons/md";
import { FaUpload } from "react-icons/fa";

const ExecutiveDashboardOne = () => {
    const [executiveId, setExecutiveId] = useState(null)
    const [profileImg, setProfileImg] = useState('');

    const [profilePhoto, setProfilePhoto] = useState(null)
    const [profilePhotoURL, setProfilePhotoURL] = useState(null)
    const [showProfilePhotoURL, setShowProfilePhotoURL] = useState(null)

    useEffect(() => {
        getExecutiveId();
        axios.get(`https://api.bakpoket.com/api/BDExecutive/get-profile-photo-binary/${executiveId}`)
            .then(res => {
                setProfileImg(res.data.fileData)
            }
            )
            .catch(err => console.log(err))
    }, [executiveId])

    const getExecutiveId = () => {
        const data = localStorage.getItem('excutiveLogin')
        const parsedate = JSON.parse(data)
        if (parsedate) {
            setExecutiveId(parsedate.id)
        }
    }

    useEffect(() => {
        if (profilePhoto) {
            const url = URL.createObjectURL(profilePhoto);
            // console.log(url)
            setProfilePhotoURL(url)
        }
    }, [profilePhoto])

    const submitProfile = () => {
        const formData = new FormData()
        formData.append('ID', executiveId)
        formData.append('ProfilePhoto', profilePhoto)

        if (!profileImg) {
            axios.post('https://api.bakpoket.com/api/BDExecutive/upload-profile-photo', formData)
                .then(res => {
                    alert('Profile Updated Successfully')
                    setShowProfilePhotoURL(profilePhotoURL)
                    setProfilePhotoURL(null)
                    setProfilePhoto(null)
                })
                .catch(err => console.log(err))
        } else {
            axios.post('https://api.bakpoket.com/api/BDExecutive/upload-profile-photo', formData)
                .then(res => {
                    alert('Profile Updated Successfully')
                    setShowProfilePhotoURL(profilePhotoURL)
                    setProfilePhotoURL(null)
                    setProfilePhoto(null)
            
                })
                .catch(err => console.log(err))
        }

    }

    const cancelProfile = () => {
        setProfilePhotoURL(null)
        setProfilePhoto(null)
    }
    return (
        <div className='container rounded py-2 px-0 p-md-2 py-md-4 d-flex justify-content-center'>
            <div className='row w-100'>
                <div style={{ background: 'linear-gradient(to right, #2a4157, #ef4766)', padding: '15px 30px', borderRadius: '20px 20px 0px 0px ' }} className='col-12'>
                    <h4 style={{ color: '#fff', marginBottom: '0px' }}>Excutive Dashboard</h4>
                </div>

                <div className='col-3 d-flex flex-column align-items-center py-3 gap-2' style={{ backgroundColor: '#ef4766', height: '30rem', borderRadius: '0px 0px 0px 20px' }}>
                    <div
                        className="border flex items-center justify-center align-items-center"
                        style={{
                            width: '4rem',
                            height: '4rem',
                            borderRadius: '50%', position: 'relative',
                        }}
                    >
                        {showProfilePhotoURL ? <img src={showProfilePhotoURL} style={{ width: '100%', height: '100%', borderRadius: '50%' }} /> : (
                            <>
                                {profileImg ? <img src={`data:image/png;base64,${profileImg}`} style={{ width: '100%', height: '100%', borderRadius: '50%' }} /> : <CgProfile style={{ color: '#fff', width: '100%', height: '100%' }} />}
                            </>)}
                        <div
                            style={{
                                position: 'absolute',
                                bottom: '-8px',
                                right: '50%',
                                background: '#fff',
                                borderRadius: '50%',
                                padding: '4px',
                                border: '1px solid #ddd',
                                cursor: 'pointer',
                                height: '1.5rem',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                            data-bs-toggle="modal" data-bs-target="#myModal"
                        >
                            <MdModeEditOutline style={{ fontSize: '0.9rem' }} />
                        </div>
                    </div>

                    <NavLink
                        to="/excutive/dashboard"
                        style={({ isActive }) => ({
                            textDecoration: 'none',
                            color: isActive ? '#fff' : '#000000d0',
                            fontWeight: isActive ? 600 : 500,
                        })}
                    >
                        Profile
                    </NavLink>

                    <NavLink
                        to="/excutive/hierarchy"
                        style={({ isActive }) => ({
                            textDecoration: 'none',
                            color: isActive ? '#fff' : '#000000d0',
                            fontWeight: isActive ? 600 : 500,
                        })}
                    >
                        Hierarchy
                    </NavLink>

                    <NavLink
                        to="/excutive/referal"
                        style={({ isActive }) => ({
                            textDecoration: 'none',
                            color: isActive ? '#fff' : '#000000d0',
                            fontWeight: isActive ? 600 : 500,
                        })}
                    >
                        Referral
                    </NavLink>

                </div>
                <div style={{ backgroundColor: 'rgba(228, 232, 235, 0.88)', height: '30rem', borderRadius: '0px 0px 20px 0px' }} className=' col-9 d-flex justify-content-center align-items-center'>
                    <Outlet />
                </div>
            </div>
            <div className="modal fade" id="myModal" >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        {profilePhoto ? <div className='d-flex justify-content-center align-items-center flex-column my-2'>
                            <img src={profilePhotoURL} style={{ height: '6rem', width: '6rem' }} />
                            <div className='mt-2 d-flex gap-3'>
                                <button style={{ border: '2px solid #00c04b', backgroundColor: '#fff', color: '#00c04b' }} className='rounded px-2' onClick={submitProfile} data-bs-dismiss="modal">Submit</button>
                                <button style={{ border: '2px solid #de0a26', backgroundColor: '#fff', color: '#de0a26' }} className='rounded px-2' onClick={cancelProfile} data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div> : <div className='d-flex justify-content-center my-2'>
                            <div style={{ border: '2px solid green', width: 'fit-content',cursor:'pointer' }} className='p-2 rounded'>
                                <label htmlFor='profilePic' style={{ color: 'green' }}><FaUpload /> Upload</label>
                                <input id='profilePic' type='file' accept="image/*" style={{ display: 'none' }} onChange={(e) => setProfilePhoto(e.target.files[0])} />
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ExecutiveDashboardOne;